export const content = {
  label: 'Address',
  helperText: '',
  placeholder: 'Type your address...',
  loading: 'Looking for your address...',
  noOptionsText: 'No options',
  postcodeNoOptionsText: 'Search for your full street address, including unit number',
};
